import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { IConfirm } from './confirm.interface';


@Injectable({
    providedIn: 'root'
})
export class ConfirmService {

  private _data: Subject<IConfirm> = new Subject<IConfirm>();

  constructor() {
  }

  get data(): Observable<IConfirm> {
    return this._data.asObservable();
  }

  confirm(title: string, description: string, result: (result: boolean) => void, confirmButtonClass?: string,
          acceptBtn?: string, cancelBtn?: any, showConfirmBtn = true): void {
    this._data.next({
      description: description,
      title: title,
      result: result,
      confirmButtonClass: confirmButtonClass || 'btn-secondary',
      acceptBtn: acceptBtn || 'Aceptar' || 'btn-conversion',
      cancelBtn: cancelBtn || 'Cancelar' || 'btn-secondary',
      showConfirmBtn: showConfirmBtn
    });
  }
}
